import React from "react";
import { Box, Checkbox, FormControlLabel, Paper, Typography, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useClient } from "frontend/src/domain/client";
import { useUpdateClient } from "frontend/src/domain/client/actions";
export var ClientCabinetSettings = function (_a) {
    var clientId = _a.clientId;
    var _b = useClient(clientId), client = _b.data, isFetched = _b.isFetched;
    var updateClient = useUpdateClient(clientId);
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(Typography, { variant: "h6" }, "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"),
        React.createElement(Box, { mt: 1 }, isFetched ? (React.createElement(React.Fragment, null,
            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { color: "primary", checked: Boolean(client === null || client === void 0 ? void 0 : client.showDetails), onChange: function (event) {
                        return updateClient.mutate({ showDetails: event.target.checked });
                    } }), label: "Показывать раздел \"Мои данные\"" }),
            React.createElement(Box, { mt: 1 },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { color: "primary", checked: Boolean(client === null || client === void 0 ? void 0 : client.showTimetables), onChange: function (event) {
                            return updateClient.mutate({
                                showTimetables: event.target.checked,
                            });
                        } }), label: "Показывать раздел \"Сетки вещания\"" })))) : (React.createElement(Skeleton, null)))));
};
